'use strict';
import { addEvent } from './addEvent/addEvent';
import { pageBaner } from './pageBaner/pageBaner';

document.addEventListener('DOMContentLoaded', function () {
  pageBanerInit();
});

function pageBanerInit() {
  const elements = document.querySelectorAll('.page-baner-container');
  elements.forEach(element => {
    new pageBaner(element);
  });
}
